import { createSelector } from 'reselect';
import { RootState } from 'src/store/storeManager';

const getCreateMode = (state: RootState) => state.sceneConfiguration.showForm;

const getShowForm = createSelector([getCreateMode], (isCreate) => isCreate);

export default getShowForm;
